import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/common.css'
import './assets/css/bootstrap.css'
import './assets/iconfont/iconfont.css'
import 'normalize.css'
import "swiper/css";
import "swiper/css/free-mode";

import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/effect-creative";
import 'uno.css'
 createApp(App).use(store).use(router).mount('#app')
